import React, { useContext, useEffect, useRef, useState } from 'react';
import Navbar from '../components/Navbar';
import Sidebar from '../components/Sidebar';
import Footer from '../components/Footer';
import { MyContext } from '../context/Context';
import { add_area_api, add_city_api, add_user_api, area_delete_api, area_details_api, city_delete_api, city_details_api, city_update_api, get_user_details, update_area_api, user_delete_api, user_update_api } from '../api/api';
import { useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import api from '../api/url';

function User() {

    const add_close_Ref = useRef(null);
    const update_close_Ref = useRef(null);
    const input_password_Ref = useRef(null);
    const { stateList, state_details_api_call } = useContext(MyContext);
    const [users, setUsers] = useState([]);
    const [areaList, setAreaList] = useState([]);
    const [inputUser, setInputUser] = useState({

        user_id: "",
        firstname: "",
        lastname: "",
        mobile_no: "",
        password: "",
    });

    useEffect(() => {
        fetch_user_details();
    }, []);


    const handle_change = (e) => {
        const { name, value } = e.target;
        setInputUser({
            ...inputUser,
            [name]: value
        });
    };


    // random password generate 
    const generateRandomNumber = () => {

        input_password_Ref.current.value = "";
        const number = Math.floor(1000 + Math.random() * 9000);
        setInputUser({
            ...inputUser,
            password: number
        })
        input_password_Ref.current.value = number;
    };

    // console.log(randomNumber)


    //add user
    const add_user_api_call = async () => {
        try {
            const res = await add_user_api(inputUser);
            console.log(res);
            if (res.status === 200) {
                fetch_user_details();
                setInputUser({
                    ...inputUser,
                    firstname: "",
                    lastname: "",
                    mobile_no: "",
                    password: "",
                })
                toast.success("User Add Successfully");
                add_close_Ref.current.click();
            }
        } catch (error) {
            console.error("Add user API error:", error);
        }
    };


    //fetch user details
    const fetch_user_details = async () => {
        try {
            const res = await get_user_details();
            if (res.status === 200) {
                console.log(res.data.data);
                setUsers(res.data.data);
            }
        } catch (error) {
            console.error("User details API error:", error);
        }
    };



    // user delete
    const user_delete_api_call = async (id) => {
        try {
            const res = await user_delete_api(id);
            if (res.status === 200) {
                toast.success("User Delete Successfully");
                fetch_user_details();
            }
        } catch (error) {
            console.error("user delete api error", error);
        }
    };



    // selecte user
    const select_user = (id) => {
        const filter_user = users.filter((user) => user.id == id);
        setInputUser(filter_user[0]);
    };

    // user update
    const user_update_api_call = async () => {
        try {
            const res = await user_update_api(inputUser);
            if (res.status === 200) {
                fetch_user_details();
                console.log(res);
                toast.success("User Update Successfully");
                update_close_Ref.current.click();
            }
        } catch (error) {
            console.error("city update api error", error);
        }
    };



    return (
        <div className="wrapper">
            <Navbar />
            <Sidebar />
            <div className="content-wrapper">
                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-12 d-flex">

                                <h1 className="m-0 mr-3">Users</h1>

                            </div>
                        </div>
                    </div>
                    <div className='d-flex justify-content-end'>
                        <button
                            className='btn btn-naariyal-green'
                            data-toggle="modal"
                            data-backdrop="static"
                            data-target="#add-user"
                            onClick={() => {
                                setInputUser({
                                    ...inputUser,
                                    firstname: "",
                                    lastname: "",
                                    mobile_no: "",
                                    password: "",
                                })
                            }}
                        >
                            <i className="fas fa-plus mr-2"></i>
                            Add User
                        </button>
                    </div>
                </div>



                <section className="content">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-12">

                                <div className="card">

                                    <div className="card-body">
                                        <table id="example2" className="table table-bordered table-hover">
                                            <thead>
                                                <tr>
                                                    <th>#</th>
                                                    <th>First Name</th>
                                                    <th>Last Name</th>
                                                    <th>Mobile No</th>
                                                    {/* <th>Password</th> */}
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {users.length > 0 && users.map((user, index) => (
                                                    <tr key={index}>
                                                        <td>{index + 1}</td>
                                                        <td>{user?.firstname}</td>
                                                        <td>{user?.lastname}</td>
                                                        <td>{user?.mobile_no}</td>
                                                        {/* <td>{user?.password}</td> */}
                                                        <td >
                                                            <div className="btn-group">
                                                                <button type="button" className="btn btn-naariyal-green dropdown-toggle" data-toggle="dropdown">Action</button>
                                                                <div className="dropdown-menu" role="menu">
                                                                    <a
                                                                        className="dropdown-item text-info"
                                                                        data-toggle="modal"
                                                                        data-backdrop="static"
                                                                        data-target="#update_user"
                                                                        onClick={() => select_user(user?.id)}
                                                                    >
                                                                        <i className="nav-icon fas fa-pencil mr-2"></i>
                                                                        Update
                                                                    </a>
                                                                    <div className="dropdown-divider"></div>
                                                                    <a
                                                                        className="dropdown-item text-danger"
                                                                        onClick={() => user_delete_api_call(user?.id)}
                                                                    >
                                                                        <i className="nav-icon fas fa-trash-alt mr-2"></i>
                                                                        Delete
                                                                    </a>
                                                                </div>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                    {/* add user modal */}
                    <div className="modal fade" id="add-user" tabIndex={-1} role="dialog" aria-labelledby="addCityModal" aria-hidden="true">
                        <div className="modal-dialog modal-dialog-centered" role="document">
                            <div className="modal-content">
                                <div className="modal-header border-0">
                                    <h5>Add User</h5>
                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close" ref={add_close_Ref}>
                                        <span aria-hidden="true">×</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <div className="input-group">
                                        <div className='w-100 mb-3'>
                                            <label htmlFor="firstname">First Name</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Enter First Name"
                                                id='firstname'
                                                name='firstname'
                                                value={inputUser.firstname}
                                                onChange={handle_change}
                                            />
                                        </div>
                                        <div className='w-100 mb-3'>
                                            <label htmlFor="lastname">Last Name</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Enter Last Name"
                                                id='lastname'
                                                name='lastname'
                                                value={inputUser.lastname}
                                                onChange={handle_change}
                                            />
                                        </div>
                                        <div className='w-100 mb-3'>
                                            <label htmlFor="mobile_no">Mobile No</label>
                                            <input
                                                type="number"
                                                className="form-control"
                                                placeholder="Enter Mobile No"
                                                id='mobile_no'
                                                name='mobile_no'
                                                value={inputUser.mobile_no}
                                                onChange={handle_change}
                                            />
                                        </div>
                                        <div className='w-100 mb-3'>
                                            <label htmlFor="password">Password</label>
                                            <input
                                                type="number"
                                                className="form-control"
                                                placeholder="Enter Password"
                                                id='password'
                                                name='password'
                                                value={inputUser.password}
                                                onChange={handle_change}
                                                ref={input_password_Ref}
                                            />
                                            <button
                                                className="btn btn-warning btn-sm mt-2"
                                                onClick={generateRandomNumber}
                                            >
                                                Generate Password
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div className="modal-footer border-0">
                                    <button
                                        type="button"
                                        className="btn btn-naariyal-green w-25 m-auto"
                                        onClick={add_user_api_call}
                                    >
                                        Save
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* update user modal */}
                    <div className="modal fade" id="update_user" tabIndex={-1} role="dialog" aria-labelledby="addCityModal" aria-hidden="true">
                        <div className="modal-dialog modal-dialog-centered" role="document">
                            <div className="modal-content">
                                <div className="modal-header border-0">
                                    <h5>
                                        Update User
                                    </h5>
                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close" ref={update_close_Ref}>
                                        <span aria-hidden="true">×</span>
                                    </button>
                                </div>
                                <div className="modal-body">

                                    <div className="mb-4 d-flex justify-content-center">
                                        <div className='admin-profile'>
                                            <img className="profile-user-img img-fluid img-circle" src={`${api.imageUrl}${inputUser?.user_profile}`} alt="User profile picture" />
                                        </div>
                                    </div>

                                    <div className="input-group">
                                        <div className='w-100 mb-3'>
                                            <label htmlFor="username">User Name</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Enter User Name"
                                                id='username'
                                                name='username'
                                                value={inputUser?.username}
                                                onChange={handle_change}
                                            />
                                        </div>
                                        <div className='d-flex'>
                                            <div className='w-100 mb-3 mr-2'>
                                                <label htmlFor="firstname">First Name</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Enter First Name"
                                                    id='firstname'
                                                    name='firstname'
                                                    value={inputUser?.firstname}
                                                    onChange={handle_change}
                                                />
                                            </div>
                                            <div className='w-100 mb-3'>
                                                <label htmlFor="lastname">Last Name</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Enter Last Name"
                                                    id='lastname'
                                                    name='lastname'
                                                    value={inputUser?.lastname}
                                                    onChange={handle_change}
                                                />
                                            </div>
                                        </div>
                                        <div className='w-100 mb-3'>
                                            <label htmlFor="mobile_no">Mobile No</label>
                                            <input
                                                type="number"
                                                className="form-control"
                                                placeholder="Enter Mobile No"
                                                id='mobile_no'
                                                name='mobile_no'
                                                value={inputUser?.mobile_no}
                                                onChange={handle_change}
                                            />
                                        </div>
                                        <div className='w-100 mb-3'>
                                            <label htmlFor="email">Email Id</label>
                                            <input
                                                type="number"
                                                className="form-control"
                                                placeholder="Enter Email Id"
                                                id='email'
                                                name='email'
                                                value={inputUser?.email}
                                                onChange={handle_change}
                                            />
                                        </div>
                                        {/* <div className='w-100 mb-3'>
                                            <label htmlFor="password">Password</label>
                                            <input
                                                type="number"
                                                className="form-control"
                                                placeholder="Enter Password"
                                                id='password'
                                                name='password'
                                                value={inputUser?.password}
                                                onChange={handle_change}
                                            />
                                            <button
                                                className="btn btn-warning btn-sm mt-2"
                                                onClick={generateRandomNumber}
                                            >
                                                Generate Password
                                            </button>
                                        </div> */}
                                    </div>
                                </div>
                                <div className="modal-footer border-0">
                                    <button
                                        type="button"
                                        className="btn btn-naariyal-green w-25 m-auto"
                                        onClick={user_update_api_call}
                                    >
                                        Save
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                </section>
            </div>
            <Footer />
        </div>
    );
}

export default User;
